import { createReducer, on } from '@ngrx/store';
import { QRTemplate, QRTemplatesListMeta } from '../models/qr-template.model';
import { QRTemplateDetail } from '../models/qr-template-detail.model';
import * as QRTemplatesActions from './qr-templates.actions';

export interface QRTemplatesLoadParams {
  page?: number;
  perPage?: number;
  search?: string;
  sort?: string;
  sortDirection?: string;
}

export interface QRTemplatesState {
  qrTemplates: QRTemplate[];
  meta: QRTemplatesListMeta | null;
  currentTemplate: QRTemplateDetail | null;
  isLoading: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  error: string | null;
  lastLoadParams: QRTemplatesLoadParams;
}

const initialState: QRTemplatesState = {
  qrTemplates: [],
  meta: null,
  currentTemplate: null,
  isLoading: false,
  isSaving: false,
  isDeleting: false,
  error: null,
  lastLoadParams: {},
};

export const qrTemplatesReducer = createReducer(
  initialState,

  on(QRTemplatesActions.loadQRTemplates, (state, { page, perPage, search, sort, sortDirection }) => ({
    ...state,
    isLoading: true,
    error: null,
    lastLoadParams: { page, perPage, search, sort, sortDirection },
  })),
  on(QRTemplatesActions.loadQRTemplatesSuccess, (state, { qrTemplates, meta }) => ({
    ...state,
    qrTemplates,
    meta,
    isLoading: false,
  })),
  on(QRTemplatesActions.loadQRTemplatesFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(QRTemplatesActions.resetQRTemplatesState, () => initialState),

  // Load single template
  on(QRTemplatesActions.loadQRTemplate, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(QRTemplatesActions.loadQRTemplateSuccess, (state, { template }) => ({
    ...state,
    currentTemplate: template,
    isLoading: false,
  })),
  on(QRTemplatesActions.loadQRTemplateFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Create template
  on(QRTemplatesActions.createQRTemplate, (state) => ({
    ...state,
    isSaving: true,
    error: null,
  })),
  on(QRTemplatesActions.createQRTemplateSuccess, (state, { template }) => ({
    ...state,
    currentTemplate: template,
    isSaving: false,
  })),
  on(QRTemplatesActions.createQRTemplateFailure, (state, { error }) => ({
    ...state,
    isSaving: false,
    error,
  })),

  // Update template
  on(QRTemplatesActions.updateQRTemplate, (state) => ({
    ...state,
    isSaving: true,
    error: null,
  })),
  on(QRTemplatesActions.updateQRTemplateSuccess, (state, { template }) => ({
    ...state,
    currentTemplate: template,
    isSaving: false,
  })),
  on(QRTemplatesActions.updateQRTemplateFailure, (state, { error }) => ({
    ...state,
    isSaving: false,
    error,
  })),

  // Delete template
  on(QRTemplatesActions.deleteQRTemplate, (state) => ({
    ...state,
    isDeleting: true,
    error: null,
  })),
  on(QRTemplatesActions.deleteQRTemplateSuccess, (state) => ({
    ...state,
    currentTemplate: null,
    isDeleting: false,
  })),
  on(QRTemplatesActions.deleteQRTemplateFailure, (state, { error }) => ({
    ...state,
    isDeleting: false,
    error,
  })),

  // Reset current template
  on(QRTemplatesActions.resetCurrentQRTemplate, (state) => ({
    ...state,
    currentTemplate: null,
    error: null,
  })),
);
